export default __webpack_public_path__ + "static/media/head01_zh_cn_sp.b779a64e.png";